<template>
  <section class="section is-marginless">
    <div class="columns is-centered">
      <div class="column is-half">
        <h3 class="subtitle">Invite a Customer</h3>
        <h3>Enter a phone number to send invitation link</h3>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-half">
        <b-field>
          <PhoneCountryPicker ref="phone_country_picker"></PhoneCountryPicker>
          <b-input placeholder="123-457-7890" size="is-medium" icon-pack="fa" icon="sms" v-model="phone_number" expanded></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-half">
        <a class="button is-outlined is-medium is-primary is-fullwidth" @click="save" v-bind:class="{ 'is-loading': is_loading }" v-bind:dir="is_loading">Send SMS</a>
      </div>
    </div>
  </section>
</template>

<script>

  import UserService from './service'
  import PhoneCountryPicker from '@/components/common/PhoneCountryPicker'
  import { ToastProgrammatic as Toast } from 'buefy'

  export default {

    name: 'InviteUser',

    data () {
      return {
        phone_number: null,
        is_loading: false
      }
    },

    components: {
      PhoneCountryPicker
    },

    methods: {

      save(){

        this.is_loading = true;

        let phone_country = this.$refs.phone_country_picker.selected_country;
        if (phone_country){
          phone_country = phone_country.code;
        }

        UserService.inviteUserViaPhone(phone_country, this.phone_number, (err, invited) => {

          this.is_loading = false;

          if (err){
            Toast.open({type: 'is-danger', message: err.message})
            return;
          }

          Toast.open({type: 'is-success', message: `Invitation successfully sent to ${this.phone_number}`})

        })

      }

    }
  }

</script>



// WEBPACK FOOTER //
// src/components/user/InviteUser.vue